import React, { useState, useMemo, useEffect } from 'react'
import { WorkflowErrors } from '../contexts/WorkflowErrors';
import { getTaskObj } from '../utils/helpers';
import rison from "rison";
import { splitTaskReferenceName } from '../utils/helpers';
import { TaskType } from '../utils/constants';
import _ from 'lodash';
import {
    createTaskNode,
    createSwitchComponent,
    createForkComponent,
    createDoWhileComponent,
    createSubWorkflowComponent,
    createTriggerApprovalComponent,
} from '../utils/taskNodeCreators';
export const useWorkflowTasks = (setIsModified) => {
    // Core task data
    const [tasks, setTasks] = useState([]);
    const [taskErrors, setTaskErrors] = React.useContext(WorkflowErrors);
    const [taskData, setTaskData] = useState("");
    const [clickedTask, setClickedTask] = useState("");
    const [nodeClicked, setNodeClicked] = useState(null);
    const [taskChange, setTaskChange] = useState(false)
    // Task navigation and selection
    const [clickedWorkflowNodeTaskRef, setClickedWorkflowNodeTaskRef] = useState(null);
    const [selectedTaskRison, setSelectedTaskRison] = useState("");

    // Task interaction states
    const [clickedAddBtnNode, setClickedAddBtnNode] = useState("");
    const [clickedDeletePathBtnNode, setClickedDeletePathBtnNode] = useState("");
    const [clickedDeleteBtnNode, setClickedDeleteBtnNode] = useState({
        ref: null,
        openDialog: false,
        header: "",
        message: "",
    });
    const [showTasksPopper, setShowTasksPopper] = useState(false);
    const [taskSelectedFromList, setTaskSelectedFromList] = useState("");
    const [selectedForkCase, setSelectedForkCase] = useState(null);

    // Task loading states
    const [isTaskDataLoading, setIsTaskDataLoading] = useState(false);

    const selectedTask = useMemo(
        () => selectedTaskRison && rison.decode(selectedTaskRison),
        [selectedTaskRison]
    );
    const handleWorkflowAddBtnClick = (nodeRefObj) => {
        setClickedAddBtnNode(nodeRefObj.ref);
        setShowTasksPopper(true);
    };

    const handleSwitchCaseDeleteBtnClick = (nodeRefObj) => {
        setClickedDeletePathBtnNode(nodeRefObj.ref);
        setShowTasksPopper(true);
    };

    const handleWorkflowDeleteBtnClick = (nodeRefObj) => {
        setClickedDeleteBtnNode({
            ref: nodeRefObj.ref,
            openDialog: true,
            header: "Confirmation",
            message: "Are you sure you want to delete this task?",
        });
    };

    const closeTasksPopper = () => {
        setShowTasksPopper(false);
        setClickedAddBtnNode(null);
        setClickedDeletePathBtnNode(null);
    };
    const handleTaskSelectedFromList = (selectedTask) => {
        setTaskSelectedFromList(selectedTask);
    };

    useEffect(() => {
        setTaskChange((prev) => !prev)
    }, [tasks])
    function findNode(tasks, parentTaskReferenceName) {
        let taskIndex = -1;

        for (const task of tasks) {
            taskIndex++;
            if (task.taskReferenceName != parentTaskReferenceName) {
                if (task.type === TaskType.Switch) {
                    const { defaultCase, decisionCases } = task;
                    for (let index = 0; index < 2; index++) {
                        if (index == 0) {
                            const obj = findNode(defaultCase, parentTaskReferenceName);
                            if (obj != null) {
                                return obj;
                            }
                        } else if (index == 1) {
                            if (decisionCases && !_.isEmpty(decisionCases)) {
                                for (const key in decisionCases) {
                                    const decisionCase = decisionCases[key];
                                    const obj = findNode(decisionCase, parentTaskReferenceName);
                                    if (obj != null) {
                                        return obj;
                                    }
                                }
                            }
                        }
                    }
                } else if (task.type === TaskType.ForkJoin) {
                    if (task.forkTasks && task.forkTasks.length > 0) {
                        for (let index = 0; index < task.forkTasks.length; index++) {
                            const forktask = task.forkTasks[index];
                            const obj = findNode(forktask, parentTaskReferenceName);
                            if (obj != null) {
                                return obj;
                            }
                        }
                    }
                } else if (task.type === TaskType.DoWhile) {
                    const { loopOver } = task;
                    if (task.loopOver && task.loopOver.length > 0) {
                        for (let index = 0; index < task.loopOver.length; index++) {
                            const looptask = task.loopOver;
                            const obj = findNode(looptask, parentTaskReferenceName);
                            if (obj != null) {
                                return obj;
                            }
                        }
                    }
                } else if (taskIndex + 1 == tasks.length) {
                    return null;
                }
            } else if (task.taskReferenceName === parentTaskReferenceName) {
                return { task, tasks, taskIndex };
            }
        }
    }
    function insertTask(
        allTasks,
        parentTaskReferenceName,
        switchDetails,
        taskObj,
        followingTasks = []
    ) {
        if (parentTaskReferenceName === "__start") {
            if (allTasks) {
                allTasks.splice(0, 0, taskObj);
                if (followingTasks.length > 0) {
                    allTasks.splice(1, 0, ...followingTasks);
                }
                setTasks(_.cloneDeep(allTasks));
            }
            closeTasksPopper();
            return;
        }
        let { task, tasks, taskIndex } = findNode(
            allTasks,
            parentTaskReferenceName
        );

        if (task && task.type === TaskType.Switch) {
            if (!task.decisionCases || _.isEmpty(task.decisionCases)) {
                task.decisionCases = {};
            }
            // create case note node
            let caseNode = createTaskNode(
                switchDetails.caseName,
                switchDetails.caseName,
                TaskType.SwitchCase,
                TaskType.Label
            );
            task.decisionCases[switchDetails.caseName] = [
                caseNode,
                taskObj,
                ...followingTasks,
            ];
            setTasks(_.cloneDeep(allTasks));
        } else if (task && task.type === TaskType.ForkJoin) {
            if (!task.forkTasks || _.isEmpty(task.forkTasks)) {
                task.forkTasks = [[]];
            }
            let pathNo = task.forkTasks.length + 1;
            let forkBranchNode = createTaskNode(
                TaskType.ForkBranch + " PATH " + `${pathNo}`,
                TaskType.ForkBranch,
                TaskType.ForkBranch,
                TaskType.Label
            );
            let newForkBranch = [];
            newForkBranch.push(forkBranchNode);
            newForkBranch.push(taskObj);
            newForkBranch.push(...followingTasks);
            task.forkTasks.push(newForkBranch);

            setTasks(_.cloneDeep(allTasks));
        } else if (task && task.type === TaskType.DoWhile) {
            if (!task.loopOver || _.isEmpty(task.loopOver)) {
                task.loopOver = [];
            }
            task.loopOver.splice(0, 0, taskObj);
            if (followingTasks.length > 0) {
                task.loopOver.splice(1, 0, ...followingTasks);
            }
            setTasks(_.cloneDeep(allTasks));
        } else {
            tasks.splice(taskIndex + 1, 0, taskObj);
            if (followingTasks.length > 0) {
                tasks.splice(taskIndex + 2, 0, ...followingTasks);
            }

            setTasks(_.cloneDeep(allTasks));
        }

        if (setIsModified) setIsModified(true);
        closeTasksPopper();
    }

    const addTaskFromHook = (newTask, switchTaskDetails = null) => {
        let parentTaskReferenceName = clickedAddBtnNode;
        let taskObj = null;

        if (newTask) {
            let refObj = { ref: "" };
            if (newTask.task === TaskType.Switch) {
                const { switchNode, endOfSwitchNode } = createSwitchComponent(newTask);
                if (switchNode && endOfSwitchNode) {
                    insertTask(
                        tasks,
                        parentTaskReferenceName,
                        switchTaskDetails,
                        switchNode,
                        [endOfSwitchNode]
                    );
                    refObj.ref = switchNode.taskReferenceName;
                }
            } else if (newTask.task === TaskType.ForkJoin) {
                const { forkJoinNode, joinNode, joinLabelNode } = createForkComponent();
                if (forkJoinNode && joinNode && joinLabelNode) {
                    insertTask(
                        tasks,
                        parentTaskReferenceName,
                        switchTaskDetails,
                        forkJoinNode,
                        [joinNode, joinLabelNode]
                    );
                    refObj.ref = forkJoinNode.taskReferenceName;
                }
            } else if (newTask.task === TaskType.DoWhile) {
                const { doWhileNode, endOfDoWhileNode } = createDoWhileComponent();

                if (doWhileNode && endOfDoWhileNode) {
                    insertTask(
                        tasks,
                        parentTaskReferenceName,
                        switchTaskDetails,
                        doWhileNode,
                        [endOfDoWhileNode]
                    );

                    refObj.ref = doWhileNode.taskReferenceName;
                }
            } else if (newTask.task === TaskType.TriggerApproval) {
                const {
                    startTriggerApprovalNode,
                    triggerApprovalNode,
                    fetchApprovalNode,
                    switchNode,
                    endOfSwitchNode,
                    endTriggerApprovalNode,
                } = createTriggerApprovalComponent(switchTaskDetails);

                if (startTriggerApprovalNode) {
                    insertTask(
                        tasks,
                        parentTaskReferenceName,
                        switchTaskDetails,
                        startTriggerApprovalNode
                    );
                    parentTaskReferenceName = startTriggerApprovalNode.taskReferenceName;
                }

                if (triggerApprovalNode) {
                    insertTask(
                        tasks,
                        parentTaskReferenceName,
                        switchTaskDetails,
                        triggerApprovalNode
                    );
                    parentTaskReferenceName = triggerApprovalNode.taskReferenceName;
                }
                if (fetchApprovalNode) {
                    fetchApprovalNode["inputParameters"] = {
                        requestApprovalStepsId:
                            triggerApprovalNode.taskReferenceName +
                            ".output.response.body.data.requestApprovalStepsId",
                    };

                    insertTask(
                        tasks,
                        parentTaskReferenceName,
                        switchTaskDetails,
                        fetchApprovalNode
                    );
                    parentTaskReferenceName = fetchApprovalNode.taskReferenceName;
                }

                if (switchNode && endOfSwitchNode) {
                    insertTask(
                        tasks,
                        parentTaskReferenceName,
                        switchTaskDetails,
                        switchNode,
                        [endOfSwitchNode]
                    );

                    parentTaskReferenceName = endOfSwitchNode.taskReferenceName;
                }
                if (endTriggerApprovalNode) {
                    insertTask(
                        tasks,
                        parentTaskReferenceName,
                        switchTaskDetails,
                        endTriggerApprovalNode
                    );
                }
                if (triggerApprovalNode) {
                    refObj.ref = triggerApprovalNode.taskReferenceName;
                }
            } else if (newTask.task === TaskType.SubWorkflow) {
                const subWorkflowNode = createSubWorkflowComponent();
                if (subWorkflowNode) {
                    insertTask(
                        tasks,
                        parentTaskReferenceName,
                        switchTaskDetails,
                        subWorkflowNode
                    );

                    refObj.ref = subWorkflowNode.taskReferenceName;
                }
            } else {
                taskObj = createTaskNode(
                    newTask.task,
                    newTask.task,
                    newTask.task,
                    newTask.task
                );
                insertTask(tasks, parentTaskReferenceName, switchTaskDetails, taskObj);
                refObj.ref = taskObj.taskReferenceName;
            }

            return refObj
        }
        return false
    };
    const handleTaskNodeSelection = (node) => {
        if (node.ref) {
            if (
                splitTaskReferenceName(selectedTask?.ref) ===
                splitTaskReferenceName(node.ref)
            ) {
                return false;
            }
            const taskObj = getTaskObj(tasks, node.ref);
            setNodeClicked(taskObj);
            if (
                taskObj &&
                (taskObj.name === TaskType.EndOfSwitch ||
                    taskObj.name === TaskType.SwitchCase ||
                    taskObj.name === TaskType.Default ||
                    taskObj.name === TaskType.ForkBranch ||
                    taskObj.name === TaskType.EndOfForkJoin ||
                    taskObj.name === TaskType.EndOfDoWhile ||
                    taskObj.name === TaskType.Label ||
                    (taskObj.isSubWF === true && taskObj.name !== TaskType.SubWorkflow))
            ) {

                return false
            }

            setClickedWorkflowNodeTaskRef(node.ref);
            setSelectedTaskRison(rison.encode(node));
            return taskObj
        }
        return false
    }
    return {
        // Core task data
        tasks, setTasks,
        taskErrors, setTaskErrors,
        taskData, setTaskData,
        clickedTask, setClickedTask,
        nodeClicked, setNodeClicked,

        // Task navigation and selection
        clickedWorkflowNodeTaskRef, setClickedWorkflowNodeTaskRef,
        selectedTaskRison, setSelectedTaskRison,

        // Task interaction states
        clickedAddBtnNode, setClickedAddBtnNode,
        clickedDeletePathBtnNode, setClickedDeletePathBtnNode,
        clickedDeleteBtnNode, setClickedDeleteBtnNode,
        showTasksPopper, setShowTasksPopper,
        taskSelectedFromList, setTaskSelectedFromList,
        selectedForkCase, setSelectedForkCase,

        // Task loading states
        isTaskDataLoading, setIsTaskDataLoading,

        //
        handleTaskNodeSelection,
        handleWorkflowAddBtnClick,
        handleSwitchCaseDeleteBtnClick,
        handleWorkflowDeleteBtnClick,
        //
        selectedTask,
        //
        closeTasksPopper,
        findNode,
        addTaskFromHook,
        handleTaskSelectedFromList,
        taskChange
    }
}
